import { render, staticRenderFns } from "./tags-page-opened.vue?vue&type=template&id=32aa9798"
import script from "./tags-page-opened.vue?vue&type=script&lang=js"
export * from "./tags-page-opened.vue?vue&type=script&lang=js"
import style0 from "./tags-page-opened.vue?vue&type=style&index=0&id=32aa9798&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports